import { render, staticRenderFns } from "./MaterialArchive.vue?vue&type=template&id=c794adf2"
import script from "./MaterialArchive.vue?vue&type=script&lang=js"
export * from "./MaterialArchive.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports